import {
  IS_LOADING, SET_GOTO
} from "../actions/settingsActions";
import {
  SET_GOTO_CHANGEPASS
} from "../actions/sessionActions";

const initialState = {
  loading: false,
  goTOchangepass: false
};

const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SET_GOTO_CHANGEPASS:
      return {
        ...state,
        goTOchangepass: action.goto,
      };
    case SET_GOTO:
      return {
        ...state,
        goTOchangepass: action.goto,
      };
    default:
      return state;
  }
}

export default SettingsReducer;
